// extracted by mini-css-extract-plugin
export default {"select":"_select_select__GvrmW","dark":"_select_dark__RR+uF","light":"_select_light__pX0ht"};